<script setup lang="ts">
import {nextTick, type PropType, ref} from 'vue';
import {THEME_CHANGE_EMIT, THEME_REMOVE_EMIT} from '@/base/cabConstants';
import type {CabTheme} from 'common';
import DeleteButton from '@/views/icons/DeleteIcon.vue';

const emits = defineEmits([THEME_REMOVE_EMIT, THEME_CHANGE_EMIT]);
const props = defineProps({
    theme: {
        type    : Object as PropType<CabTheme>,
        required: true,
    },
});
defineExpose({
    firstEdit,
});

const theme       = ref<CabTheme>(props.theme);
const nameField   = ref<HTMLInputElement | null>(null);
const nameEditing = ref<boolean>(false);

let isFirstEdit: boolean = false;

//==========================================
function firstEdit() {
    isFirstEdit = true;
    startEditingName();
}

//==========================================;
function startEditingName() {
    nameEditing.value = true;
    nextTick(() => nameField.value!.focus());
}

function stopEditingName() {
    nameEditing.value = false;
    nameField.value!.blur();
    if (isFirstEdit) {
        if (!props.theme.name.trim()) {
            onDelete();
        }
        isFirstEdit = false;
    }
}

//==========================================;
function dynInputClass(b: boolean) {
    return b ? `bg-white border-gray-300 rounded-md shadow-xl` : `bg-yellow-100`;
}

function onDelete() {
    emits(THEME_REMOVE_EMIT, theme.value);
}

function onChange() {
    emits(THEME_CHANGE_EMIT, theme.value);
}
</script>

<template>
    <div
        class="flex flex-row items-center w-full font-medium m-0.5 p-1 bg-yellow-100 text-gray-900"
    >
        <div class="flex-1 px-3 py-1" title="thema naam">
            <input
                class="mt-1 mr-1 px-2 py-1 border-1 w-full"
                :class="dynInputClass(nameEditing)"
                type="text"
                ref="nameField"
                v-model="theme.name"
                @input="onChange"
                @click="startEditingName()"
                @focus="startEditingName()"
                @keyup.enter="stopEditingName()"
                @blur="stopEditingName()"
                placeholder="thema naam"
            />
        </div>

        <DeleteButton @click="onDelete()"/>
    </div>
</template>
